export const blockIconsHomeGoogleWifiNew = (
	<span className='material-symbols-outlined'>google_wifi</span>
);
